import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaUserCircle } from 'react-icons/fa';
import './HospitalNavbar.css';

const HospitalNavbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') {
      setIsDarkMode(true);
      document.documentElement.classList.add('dark-mode');
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
    if (!isDarkMode) {
      document.documentElement.classList.add('dark-mode');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark-mode');
      localStorage.setItem('theme', 'light');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('hospitalAuthenticated');
    navigate('/login');
  };

  const handleEditProfile = () => {
    navigate('/hospital/edit-profile');
  };
  
  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <i className="fas fa-hospital medical-icon"></i>
        <span>Hospital Dashboard</span>
      </div>

      <div className="nav-links">
        <Link to="/hospital-dashboard" 
          className={`nav-link ${location.pathname === '/hospital-dashboard' ? 'active' : ''}`}>
          <i className="fas fa-chart-line"></i>
          Dashboard
        </Link>
        <Link to="/hospital/reports" 
          className={`nav-link ${location.pathname === '/reports' ? 'active' : ''}`}>
          <i className="fas fa-file-medical-alt"></i>
          Reports
        </Link>
      </div>
      
      <div className="nav-actions">
        <button className="theme-toggle" onClick={toggleTheme}>
          <i className={`fas ${isDarkMode ? 'fa-sun' : 'fa-moon'}`}></i>
        </button>

        <div className="user-profile-container" ref={dropdownRef}>
          <div 
            className="user-profile" 
            onClick={() => setShowDropdown(!showDropdown)}
          >
            <div className="profile-image">
              <FaUserCircle />
            </div>
          </div>
          {showDropdown && (
            <div className="profile-dropdown">
              <button onClick={handleEditProfile}>
                <i className="fas fa-user-md"></i> Edit Hospital Profile
              </button>
              <button onClick={handleLogout}>
                <i className="fas fa-sign-out-alt"></i> Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default HospitalNavbar;